import {isInstanceOf, isPlainObject} from 'rlink-type-utils';

/**
 * Returns the value that would be associated with the given key
 * in the entries() iterator of the given object. (Note that for
 * sets this simply returns the given key).
 *
 * @param  {IterableCollection} obj
 * @param  {*} key
 * @return {*} key's value
 */
export default function valueForKey (obj, key) {
  if (!this.isCollection(obj)) {
    throw new Error(`Cannot key into non-collection object: ${obj}`);
  }
  if (isInstanceOf(obj, Array)) {
    return obj[key];
  } else if (obj && typeof obj.get === 'function') {
    return obj.get(key);
  } else if (isInstanceOf(obj, Set) || isInstanceOf(obj, WeakSet)) {
    if (obj.has(key)) {
      return key;
    } else {
      return undefined;
    }
  } else if (isPlainObject(obj)) {
    return obj[key];
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/valueForKey.js